import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import { useCenter } from "../../hooks/centers.hooks";
import PenIcon from "../icons/PenIcon";
import PrimaryButton from "../PrimaryButton";
import CenterForm, { CenterFormHandler } from "../forms/CenterForm";
import { useRef } from "react";
import { updateCenter } from "../../mutations/center.mutations";
import { useMutation, useQueryClient } from "react-query";

type CenterModalProps = {
	id?: number;
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

const CenterModal = ({ id, isOpen, onClose }: CenterModalProps) => {
	const { data: center } = useCenter(id);
	const ref = useRef<CenterFormHandler>(null);
	const queryClient = useQueryClient();
	const { mutate: mutateUpdateCenter } = useMutation(updateCenter, {
		onSuccess: () => {
			onClose();
			queryClient.invalidateQueries(["center"]);
		},
	});
	const handleSubmit = async () => {
		if (ref.current) {
			const valid = await ref.current.valid();
			if (valid) {
				mutateUpdateCenter({
					center: {
						id,
						...ref.current.values(),
					},
				});
			}
		}
	};

	if (!center) {
		return <></>;
	}
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<PenIcon w="24px" h="24px" color="brand.700"></PenIcon>
						</Flex>
						<Box lineHeight="48px">Editer les informations du centre</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<CenterForm ref={ref} value={center}></CenterForm>
				</ModalBody>
				<ModalFooter>
					<PrimaryButton onClick={handleSubmit}>Sauvegarder</PrimaryButton>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default CenterModal;
